import React, { useState, useEffect, FC } from "react";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button } from "reactstrap";
import {
  TableColumnsType,
  Table,
  Progress,
  Select,
  Input,
  Empty,
  Flex,
  Spin,
} from "antd";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import RateContractAside from "./RateContractAside";
import { SearchOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import purchaseOrderApis from "../../api/master/PurchaseOrder";
import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
const RateContractAprrovals: FC = () => {
  const [sm, setSm] = useState(false);

  const navigate = useNavigate();

   const columns = [
    {
      title: "Contract #",
      dataIndex: "orderId",
      key: "orderId",
      width: 200,
      fixed: "left",
      render(text: any, record: any) {
        // Sanitize orderNumber for use in CSS selector (replace invalid characters)
        const sanitizedId =
          record?.orderNumber?.replace(/[^a-zA-Z0-9-_]/g, "-") || "";
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`draftStatus-${sanitizedId}`}
              onClick={() => {
                if (record?.orderStatus == "Draft") {
                  navigate(`/rate-contract-new/`, {
                    state: {
                      draftId: record?.orderNumber,
                    },
                  });
                } else {
                  navigate(
                    `/view-rate-contract/${
                      record?.rateContractId || record?.id
                    }`,
                    {
                      state: {
                        status: record?.orderStatus,
                      },
                    }
                  );
                }
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={record?.orderStatus == "Draft" ? "info" : ""}
              id={`draftStatus-${sanitizedId}`}
              direction="right"
              text={
                record?.orderStatus == "Draft"
                  ? "Click To Continue Order Creation"
                  : "Click To View Order Details"
              }
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "Contract Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: 150,
      fixed: "left",
      render: (date: any) => <span>{FormatDate(date)}</span>,
    },
    {
      title: "Supplier Name ",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 22)}... ` : text}
            </span>
            {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Start Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 200,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      width: 200,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      width: 200,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.buyer;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
    // {
    //   title: "Action",
    //   key: "operation",
    //   fixed: "right",
    //   width: 150,
    //   render: (text: any, record: any, index: any) => (
    //     <>
    //       <Button
    //         size="sm"
    //         // color=""
    //         onClick={() => {
    //           navigate(`/poHistory/${record.orderNumber}`);
    //         }}
    //       >
    //         <Icon name="history" title="View Version History" />
    //       </Button>
    //     </>
    //   ),
    // },
  ];

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="approvals-rate-contract"
      title="Pending Approvals"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <RateContractAside updateSm={setSm} sm={sm} />
        </div>
      }
      extra={{
        tableScrollX: 1100,
      }}
    />
  );
};

export default RateContractAprrovals;
